module.exports = __webpack_public_path__ + "img/lzcjdx.dc294b32.png";